import React, { useRef, useState, useEffect } from 'react';
import './PresetQuestions.css';

const PresetQuestions = ({ onSelectQuestion }) => {
    const [randomizedQuestions, setRandomizedQuestions] = useState([]);
    
    const allQuestions = [
        "Tell me about your X-ray cameras.",
        "Tell me about your SWIR camera options.",
        "Tell me about your visible cameras.",
        "Tell me about your Laue diffraction systems.",
        "What kind of applications are your cameras typically used for?",
        "What software and integration options do you offer with your cameras?",
        "Do you provide support for OEM and custom camera solutions?",
        "What industries do your products serve?",
    ];

    useEffect(() => {
        const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());
        setRandomizedQuestions(shuffled);
    }, []);


    return (
        <div className="preset-questions-container">
            <div className="preset-questions-vertical">
                {randomizedQuestions.slice(0, 8).map((question, index) => (
                    <button
                        key={index}
                        onClick={() => onSelectQuestion(question)}
                        className="preset-question-button"
                    >
                        {question}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default PresetQuestions;